import { configure, defineRule } from "vee-validate";
import { required, email, min, max, url } from "@vee-validate/rules";
import inValidator from "./rules/in.es.js";
import passwordValidator from "./rules/password.es.js";
import biggerOrEqualValidator from "./rules/bigger-or-Equal.es.js";
import biggerThanValidator from "./rules/bigger-than.es.js";
import lowerOrEqualValidator from "./rules/lower-or-Equal.es.js";
import selectIsRequired from "./rules/select-required.es.js";
import { siretValidator } from "./rules/siret.es.js";
import { sirenValidator } from "./rules/siren.es.js";
import { phoneValidator } from "./rules/phone.es.js";
import { postalCodeValidator } from "./rules/postalCode.es.js";
import { emailListValidator } from "./rules/email-list.es.js";
import { getI18n } from "../uikit.i18n.es.js";
function useDefaultValidators(i18n = getI18n()) {
  configure({
    generateMessage: (context) => {
      return i18n.global.t(`uiKit.validation.rules.${context.rule.name}`, context.rule.params);
    }
  });
  defineRule("required", required);
  defineRule("email", email);
  defineRule("min", min);
  defineRule("max", max);
  defineRule("siren", sirenValidator);
  defineRule("siret", siretValidator);
  defineRule("phone", phoneValidator);
  defineRule("postalCode", postalCodeValidator);
  defineRule("isEmailList", emailListValidator);
  defineRule("url", url);
  defineRule("biggerthan", biggerThanValidator);
  defineRule("lowerOrEqual", lowerOrEqualValidator);
  defineRule("biggerOrEqual", biggerOrEqualValidator);
  defineRule("password", passwordValidator);
  defineRule("in", inValidator);
  defineRule("selectRequired", selectIsRequired);
}
export {
  useDefaultValidators as default
};
//# sourceMappingURL=index.es.js.map
